import React, { createContext, useEffect, useState } from "react";
import {
  getOrderDetails,
  getAceeptResponse,
  getRejectResponse,
  userLogout,
  submitMobileLink,
} from "../../../apis/Api";
import { useNavigate, useLocation } from "react-router";
import RouteConstant from "../../../constants/routesContent.json";
import OrderConstant from "../../../constants/contentFile.json";
import { useCookies } from "react-cookie";
import {
  processStatus,
  validateRegesterdMobileNumber,
  getCookie,
} from "../../../utils/service";

export const OrderDetailContext = createContext({});

export const OrderDetailContextProvider = ({ children }) => {
  const [orderDetails, setOrderDetails] = useState("");
  const [visibleConfirm, setVisibleConfirm] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [confirmMessage, setConfirmMessage] = useState("");
  const [requestStatus, setRequestStatus] = useState();
  const [conformFunc, setConformFunc] = useState("");
  const [updateStatus, setUpdateStatus] = useState("");
  const [showLogoutAlert, setShowLogoutAlert] = useState(false);
  const [logoutAlertMessage, setLogoutAlertMessage] = useState("");
  const [pageTitle, setPageTitle] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const dataFromHistory = location.state;
  const textContents = OrderConstant.detailPage;
  const orderConstants = OrderConstant.errorMessages;
  const logoutConstants = OrderConstant.logout;
  const intentHistoryConstants = OrderConstant.intenthistoryPage;
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const [apiStatus, setApiStatus] = useState("");
  const [mobileEnterMessage, setMobileEnterMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [mobileNumber, setMobileNumber] = useState();
  const [shareHistory, setShareHistory] = useState([]);
  const [driverMobileNumber, setDriverMobileNumber] = useState("");
  const [successAlert, setSuccessAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [popUpMessages, setPopUpMessages] = useState("");
  const [freightType, setFreightType] = useState("");
  const [multipleLinkSendOption, setMultipleLinkSendOption] = useState(false);
  const [pageIsOrderDetail, setPageIsOrderDetail] = useState(false);

  //to run the useEffect if the request is coming from different section so that the page will refresh
  const requestComesFrom = dataFromHistory ? "intentHistory" : "orderDetails";
  const cookieValue = getCookie("isZonalHead");
  const isZonalHead = cookieValue ? JSON.parse(cookieValue) : false;

  const getIntentData = async (e) => {
    setApiStatus("fetching");
    try {
      const intentDetails = await getOrderDetails();

      if (intentDetails.status === 200 && intentDetails?.data?.intentInfo) {
        setOrderDetails(intentDetails.data.intentInfo);
        setShareHistory(intentDetails.data.shareHistory);
        setFreightType(intentDetails?.data?.intentInfo?.freight_type);
        const intentToken = intentDetails?.data.intentInfo["request_token"];

        // setCookie("intentToken", intentToken, { path: "/" });
        const intentId = intentDetails?.data.intentInfo["intent_id"];

        setCookie("IntentId", intentId, { path: "/" });
      }
    } catch (error) {
      if (error?.response?.data?.statusCode === 401) {
        setShowAlert(true);
        setAlertMessage(orderConstants.sessionExpired);
      } else {
        setAlertMessage(orderConstants.somethingWrong);
        setShowAlert(true);
      }
    }
    setApiStatus("completed");
  };

  const sendMobileLink = async () => {
    const userData = {
      driver_mobile: driverMobileNumber,
      request_token: orderDetails?.request_token,
    };
    try {
      const intentLink = await submitMobileLink(userData);

      if (intentLink?.data?.statusCode === 200) {
        setSuccessAlert(true);
        setErrorAlert(false);
        setPopUpMessages(intentLink?.data?.statusMessage);
        setDriverMobileNumber("");
        setMobileEnterMessage("");
        getIntentData();
      }
    } catch (error) {
      if (
        error?.response?.data?.statusCode === 400 ||
        error?.response?.data?.statusCode === 401
      ) {
        const errorMessage = error.response.data.statusMessage;
        setPopUpMessages(errorMessage);
        setErrorAlert(true);
      }
    }
  };

  const logout = async () => {
    try {
      if (!cookies.xAccessToken) {
        removeCookie("xAccessToken", { path: "/" });
        removeCookie("supplierId", { path: "/" });
        removeCookie("intentToken", { path: "/" });
        removeCookie("userId", { path: "/" });
        removeCookie("isZonalHead", { path: "/" });
        removeCookie("Share-Token", { path: "/" });
        navigate(RouteConstant.LOGIN);
      } else {
        const logoutData = await userLogout();

        if (logoutData?.data?.statusCode === 200) {
          removeCookie("xAccessToken", { path: "/" });
          removeCookie("supplierId", { path: "/" });
          removeCookie("userId", { path: "/" });
          removeCookie("intentToken", { path: "/" });
          removeCookie("isZonalHead", { path: "/" });
          removeCookie("Share-Token", { path: "/" });
          navigate(RouteConstant.LOGIN);
        } else {
          setShowLogoutAlert(true);
          setLogoutAlertMessage(orderConstants.somethingWrong);
        }
      }
    } catch (error) {
      setShowAlert(false);
      if (error?.response?.data?.statusCode === 401) {
        setShowLogoutAlert(true);
        setLogoutAlertMessage(orderConstants.sessionExpired);
      } else {
        setShowLogoutAlert(true);
        setLogoutAlertMessage(orderConstants.somethingWrong);
      }
    }
  };

  const toLoginPage = () => {
    navigate(RouteConstant?.LOGIN);
  };

  const btnAcceptClick = async () => {
    setApiStatus("fetching");
    setVisibleConfirm(false);
    try {
      const acceptdata = await getAceeptResponse(orderDetails.intent_id, "1");
      if (acceptdata?.data?.statusCode === 200) {
        if (freightType == "IFO") {
          setShowPopup(true);
          getIntentData();
        } else {
          const thankyouMessage = acceptdata?.data?.statusMessage;
          navigate(RouteConstant.THANK_YOU, { state: thankyouMessage });
        }
      }
    } catch (error) {
      setShowAlert(true);
      setVisibleConfirm(false);
      setAlertMessage(error.response.data.statusMessage);
      if (error?.response?.data?.statusCode === 404) {
        setShowAlert(true);
        setVisibleConfirm(false);
        setAlertMessage(error.response.data.statusMessage);
      } else if (error?.response?.data?.statusCode === 401) {
        setShowAlert(true);
        setVisibleConfirm(false);
        setAlertMessage(orderConstants.sessionExpired);
      }
    }
    setApiStatus("completed");
  };

  const btnRejectClick = async () => {
    setApiStatus("fetching");
    setVisibleConfirm(false);
    try {
      const rejectdata = await getRejectResponse(orderDetails.intent_id, "0");
      if (rejectdata?.data?.statusCode === 200) {
        const thankyouMessage = rejectdata?.data?.statusMessage;
        navigate(RouteConstant.THANK_YOU, { state: thankyouMessage });
      }
    } catch (error) {
      if (error?.response?.data?.statusCode === 400) {
        setShowAlert(true);
        setAlertMessage(error.response.data.statusMessage);
      } else if (error?.response?.data?.statusCode === 401) {
        setShowAlert(true);
        setAlertMessage(orderConstants.sessionExpired);
      }
    }

    setApiStatus("completed");
  };

  useEffect(() => {
    if (location.pathname !== RouteConstant.ORDER_DETAILS) {
      return;
    }

    window.history.pushState(null, null, window.location.href);
    const windowBackManage = () => navigate(1);
    window.addEventListener("popstate", windowBackManage);

    return () => {
      window.removeEventListener("popstate", windowBackManage);
    };
  }, [requestComesFrom]);

  useEffect(() => {
    if (dataFromHistory) {
      const intentToken = dataFromHistory["request_token"];

      //  setCookie("intentToken", intentToken, { path: "/" });
      const intentId = dataFromHistory["intent_id"];
      setCookie("IntentId", intentId, { path: "/" });
      getIntentData();
      setPageTitle(intentHistoryConstants.intentHistoryDetails);
      setPageIsOrderDetail(false);
    } else {
      getIntentData();
      setPageTitle(textContents.orderDetail);
      setPageIsOrderDetail(true);
      const intentToken = "";

      // setCookie("intentToken", intentToken, { path: "/" });
      const intentId = "";
      setCookie("IntentId", intentId, { path: "/" });
    }
  }, [requestComesFrom]);

  const handleOnChangeMobile = (value) => {
    if (!value) {
      setMobileEnterMessage("Enter mobile number");
      return;
    }
    if (!validateRegesterdMobileNumber(value)) {
      setMobileEnterMessage("Enter valid mobile number");
      return;
    }

    // If validation passes, send the link but do not clear the message immediately
    sendMobileLink();
    setShowPopup(false);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setDriverMobileNumber(value);

    if (value) {
      setMobileEnterMessage("");
    }
  };

  const handleMobileNumber = (e) => {
    e.preventDefault();
    setMobileNumber(e.target.value);
  };

  const handleClose = () => {
    setShowPopup(false);
    setDriverMobileNumber("");
    setMobileEnterMessage("");
  };

  const providerValue = {
    textContents,
    orderDetails,
    visibleConfirm,
    setVisibleConfirm,
    showAlert,
    setShowAlert,
    alertMessage,
    logout,
    confirmMessage,
    setConfirmMessage,
    btnAcceptClick,
    btnRejectClick,
    requestStatus,
    setRequestStatus,
    conformFunc,
    setConformFunc,
    updateStatus,
    setUpdateStatus,
    showLogoutAlert,
    setShowLogoutAlert,
    logoutConstants,
    logoutAlertMessage,
    processStatus,
    pageTitle,
    apiStatus,
    handleMobileNumber,
    setShowPopup,
    showPopup,
    shareHistory,
    driverMobileNumber,
    setDriverMobileNumber,
    sendMobileLink,
    handleOnChangeMobile,
    mobileEnterMessage,
    handleInputChange,
    handleClose,
    popUpMessages,
    successAlert,
    setSuccessAlert,
    errorAlert,
    setErrorAlert,
    isZonalHead,
    freightType,
    toLoginPage,
    pageIsOrderDetail,
    dataFromHistory,
  };

  return (
    <OrderDetailContext.Provider value={providerValue}>
      {children}
    </OrderDetailContext.Provider>
  );
};
